export default {
  // 初始提示文本
  initialPrompt: "双击节点可按选择的交易方向扩展相关的交易地址",
  // 多选方法说明
  multiSelectMethod:
    "多选方法：1、ctrl/⌘+鼠标左键选择多个节点。2、鼠标右键框选多个节点",
  // 节点类型提示
  node: {
    prompts: [
      "双击节点可按选择的交易方向扩展相关的交易地址",
      "可选择一个或多个节点，可点击顶部或右侧操作区的按钮体验更多功能",
      "可通过操作（ctrl+E/⌘+E）快捷键或打开左侧展开详情按钮查看节点详情",
    ],
  },
  // 边类型提示
  edge: {
    prompts: [
      "可通过操作（ctrl+E/⌘+E）快捷键或打开左侧展开详情按钮查看交易详情",
    ],
  },
  // 多节点类型提示
  morenode: {
    prompts: [
      "可点击顶部或右侧操作区的按钮体验更多功能",
      "按回车键可快速批量扩展地址交易信息",
    ],
  },
};
